<template>
  <div>
    <!-- Info Banner -->
    <div class="form-info-banner">
      <h3 class="form-info-banner-title">
        Os campos com * são de preenchimento obrigatório
      </h3>
      <p class="form-info-banner-text">
        Caso queira, você poderá salvar e continuar depois.
      </p>
    </div>

    <div class="space-y-8">
      <!-- Seção: Dados da Empresa -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Dados da empresa'"
            :TipoCliente="'Fundos'"
            :Sessao="'Dados Cadastrais'"
            :SubSessao="'Dados da Empresa'"
          />
        </div>
        <div class="form-section-content">
          <div class="form-grid-12">
            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="razaoSocial"
                >Razão social</label
              >
              <input
                class="field"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.RazaoSocial"
                type="text"
                id="razaoSocial"
                disabled="true"
                placeholder="Empresa X LTDA"
              />
            </div>
            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="cnpj"
                >CNPJ</label
              >
              <input
                class="field"
                type="text"
                id="cnpj"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Cnpj"
                disabled="true"
                placeholder="12.345.678/0001-10"
              />
            </div>
            <div
              v-if="configuracaoApelido == 'S'"
              class="col-span-4 form-field"
            >
              <div class="flex items-center gap-2">
                <label
                  class="form-field-label form-field-label-required"
                  for="apelido"
                  >Apelido</label
                >
                <i
                  class="fa fa-info-circle form-helper-icon"
                  title="O apelido deve ter entre 3 e 20 caracteres, podendo incluir letras (maiúsculas ou minúsculas) e números. Não é permitido o uso de caracteres especiais."
                ></i>
              </div>
              <input
                class="field"
                type="text"
                id="apelido"
                v-model="localFI.Apelido"
                @input="validarApelido"
                @blur="checkApelidoLength"
                @change="salvarAlteracoesLocalmente"
              />
              <p v-if="apelidoError" class="form-field-error">
                {{ apelidoError }}
              </p>
              <p v-if="camposObrigatorios.erroApelido" class="form-field-error">
                Campo obrigatório
              </p>
            </div>
          </div>
          <div class="form-grid-12">
            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="RamoAtividade"
                >Ramo de atividade</label
              >
              <select
                id="atividadePrincipal"
                @change="salvarAlteracoesLocalmente"
                class="field"
                v-model="localFI.RamoAtividade"
              >
                <option
                  v-for="item in listaAtividades"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.descricao }}
                </option>
              </select>
              <p
                v-if="camposObrigatorios.erroRamoAtividade"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>

            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="tipoInvestidor"
                >Natureza Jurídica</label
              >
              <select
                id="tipoInvestidor"
                :disabled="localFI.NaturezaJuridicaDataSincronizacao != null"
                @change="salvarAlteracoesLocalmente"
                class="field"
                v-model="localFI.NaturezaJuridicaId"
              >
                <option
                  v-for="item in listaNaturezaJuridica"
                  :key="item.Descricao"
                  :value="item.Codigo"
                >
                  {{ item.Codigo }} - {{ item.Descricao.substring(0, 150) }}
                </option>
              </select>
              <p
                v-if="camposObrigatorios.erroNaturezaJuridica"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>

            <div class="col-span-4 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="dataConstituicao"
                >Data de constituição</label
              >
              <input
                class="field"
                disabled="true"
                type="field"
                id="dataConstituicao"
                v-model="localFI.DataConstituicaoFormatada"
                placeholder="00/00/0000"
              />
            </div>
          </div>
          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label" for="pessoaContato"
                >Pessoa Contato</label
              >
              <input
                class="field"
                type="text"
                id="pessoaContato"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.PessoaContato"
              />
            </div>
            <div class="form-field">
              <label class="form-field-label" for="cargo">Cargo</label>
              <input
                class="field"
                type="text"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Cargo"
                id="cargo"
              />
            </div>
          </div>
          <div class="form-grid-12">
            <div class="col-span-3 form-field">
              <telefone-internacional
                v-if="inicializado"
                v-model="localFI.Telefone"
                label="Telefone"
                :name="'Telefone'"
                @validate="onValidateTelefone"
                @change="salvarAlteracoesLocalmente"
              />
              <p
                v-if="camposObrigatorios.erroTelefone && !localFI.Telefone"
                class="form-field-error"
              >
                Telefone obrigatório ou inválido
              </p>
            </div>

            <div class="col-span-3 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="Email"
                >E-mail</label
              >
              <input
                class="field"
                type="text"
                @blur="validarEmail"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Email"
                id="Email"
              />
              <p v-if="emailErros.Email" class="form-field-error">
                {{ emailErros.Email }}
              </p>
            </div>

            <div class="col-span-4 form-field">
              <div class="flex items-center gap-2">
                <label class="form-field-label form-field-label-required"
                  >Organização sem fins lucrativos?</label
                >
                <i
                  class="fa fa-info-circle form-helper-icon"
                  title="Marque 'Sim' se a empresa for uma associação, fundação, ONG ou entidade sem fins lucrativos."
                ></i>
              </div>
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="false"
                    :name="`SemFinsLucrativos_${index}`"
                    class="form-radio-input"
                    v-model="localFI.SemFinsLucrativos"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="true"
                    :name="`SemFinsLucrativos_${index}`"
                    class="form-radio-input"
                    v-model="localFI.SemFinsLucrativos"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Seção: Endereço Comercial -->
      <section class="form-section">
        <div class="form-section-header">
          <LabelDisclaimer
            :TamanhoFonteLabel="'H5'"
            :NomeLabel="'Endereço comercial'"
            :TipoCliente="'Fundos'"
            :Sessao="'Dados Cadastrais'"
            :SubSessao="'Endereço Comercial'"
          />
        </div>
        <div class="form-section-content">
          <div class="form-grid-12">
            <div class="col-span-2 form-field">
              <div class="flex items-center justify-between">
                <label
                  class="form-field-label form-field-label-required"
                  for="cep"
                  >CEP</label
                >
                <a
                  target="_blank"
                  class="form-link text-xs"
                  href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                  >Não sei o CEP</a
                >
              </div>
              <input
                class="field"
                type="text"
                @change="
                  salvarAlteracoesLocalmente;
                  validarCep(localFI);
                "
                v-model="localFI.Cep"
                id="cep"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoCep"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="col-span-8 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="logradouro"
                >Endereço</label
              >
              <input
                class="field"
                type="text"
                id="logradouro"
                :disabled="isDisabledEnderecoLogradouro"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Logradouro"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoLogradouro"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="col-span-2 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="numero"
                >Número</label
              >
              <input
                class="field"
                type="text"
                id="numero"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.LogradouroNumero"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoNumero"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
          </div>
          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label" for="complemento"
                >Complemento</label
              >
              <input
                class="field"
                type="text"
                id="complemento"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.LogradouroComplemento"
                placeholder=""
              />
            </div>
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="bairro"
                >Bairro</label
              >
              <input
                class="field"
                type="text"
                id="bairro"
                :disabled="isDisabledEndereco"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.Bairro"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoBairro"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
          </div>
          <div class="form-grid-3">
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="cidade"
                >Cidade</label
              >
              <input
                class="field"
                type="text"
                :disabled="isDisabledEndereco"
                v-model="localFI.Cidade"
                @change="salvarAlteracoesLocalmente"
                id="cidade"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoCidade"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="form-field">
              <label class="form-field-label form-field-label-required" for="uf"
                >UF</label
              >
              <select
                class="field"
                :disabled="isDisabledEndereco"
                id="uf"
                v-model="localFI.Uf"
                @change="salvarAlteracoesLocalmente"
              >
                <option value="null">Selecione</option>
                <option v-for="uf in ufs" :key="uf" :value="uf">
                  {{ uf }}
                </option>
              </select>
              <p
                v-if="camposObrigatorios.erroEnderecoUf"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="Pais"
                >País</label
              >
              <select
                id="Pais"
                @change="salvarAlteracoesLocalmente"
                class="field"
                v-model="localFI.Pais"
                :disabled="isDisabledEndereco"
              >
                <option value="">Selecione</option>
                <option
                  v-for="item in listaPaises"
                  :key="item.Codigo"
                  :value="item.Codigo"
                >
                  {{ item.Descricao }}
                </option>
              </select>
              <p
                v-if="camposObrigatorios.erroEnderecoPais"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
          </div>
          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Emitir Extrato em Papel</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="true"
                    name="EmitirExtratoPapel"
                    class="form-radio-input"
                    v-model="localFI.EmitirExtratoPapel"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="false"
                    name="EmitirExtratoPapel"
                    class="form-radio-input"
                    v-model="localFI.EmitirExtratoPapel"
                    @change="salvarAlteracoesLocalmente"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
              </div>
            </div>
            <div class="form-field">
              <label class="form-field-label form-field-label-required"
                >Esse endereço é o mesmo da correspondência?</label
              >
              <div class="form-radio-group">
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="1"
                    name="EnderecoCorrespondencia"
                    class="form-radio-input"
                    v-model="localFI.EnderecoCorrespondencia"
                    @change="limparCamposEnderecoCorrespondencia"
                  />
                  <span class="form-radio-label">Sim</span>
                </label>
                <label class="form-radio-item">
                  <input
                    type="radio"
                    value="2"
                    name="EnderecoCorrespondencia"
                    class="form-radio-input"
                    v-model="localFI.EnderecoCorrespondencia"
                    @change="limparCamposEnderecoCorrespondencia"
                  />
                  <span class="form-radio-label">Não</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Seção: Endereço Correspondência (Condicional) -->
      <section v-if="localFI.EnderecoCorrespondencia == 2" class="form-section">
        <div class="form-section-header">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Endereço correspondência
          </h3>
        </div>
        <div class="form-section-content">
          <div class="form-grid-12">
            <div class="col-span-2 form-field">
              <div class="flex items-center justify-between">
                <label
                  class="form-field-label form-field-label-required"
                  for="cepOutro"
                  >CEP</label
                >
                <a
                  target="_blank"
                  class="form-link text-xs"
                  href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                  >Não sei o CEP</a
                >
              </div>
              <input
                class="field"
                type="text"
                @change="
                  salvarAlteracoesLocalmente;
                  validarCepOutro(localFI);
                "
                v-model="localFI.CepOutro"
                id="cepOutro"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoOutroCep"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="col-span-8 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="logradouroOutro"
                >Endereço</label
              >
              <input
                class="field"
                type="text"
                id="logradouroOutro"
                :disabled="isDisabledEnderecoOutroLogradouro"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.LogradouroOutro"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoOutroLogradouro"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="col-span-2 form-field">
              <label
                class="form-field-label form-field-label-required"
                for="numeroOutro"
                >Número</label
              >
              <input
                class="field"
                type="text"
                id="numeroOutro"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.LogradouroNumeroOutro"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoOutroNumero"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
          </div>
          <div class="form-grid-2">
            <div class="form-field">
              <label class="form-field-label" for="complementoOutro"
                >Complemento</label
              >
              <input
                class="field"
                type="text"
                id="complementoOutro"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.LogradouroComplementoOutro"
                placeholder=""
              />
            </div>
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="bairroOutro"
                >Bairro</label
              >
              <input
                class="field"
                type="text"
                id="bairroOutro"
                :disabled="isDisabledEnderecoOutro"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.BairroOutro"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoOutroBairro"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
          </div>
          <div class="form-grid-3">
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="cidadeOutro"
                >Cidade</label
              >
              <input
                class="field"
                type="text"
                :disabled="isDisabledEnderecoOutro"
                @change="salvarAlteracoesLocalmente"
                v-model="localFI.CidadeOutro"
                id="cidadeOutro"
                placeholder=""
              />
              <p
                v-if="camposObrigatorios.erroEnderecoOutroCidade"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="ufOutro"
                >UF</label
              >
              <select
                class="field"
                :disabled="isDisabledEnderecoOutro"
                id="ufOutro"
                v-model="localFI.UfOutro"
                @change="salvarAlteracoesLocalmente"
              >
                <option value="null">Selecione</option>
                <option v-for="uf in ufs" :key="uf" :value="uf">
                  {{ uf }}
                </option>
              </select>
              <p
                v-if="camposObrigatorios.erroEnderecoOutroUf"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
            <div class="form-field">
              <label
                class="form-field-label form-field-label-required"
                for="PaisOutro"
                >País</label
              >
              <select
                id="PaisOutro"
                @change="salvarAlteracoesLocalmente"
                class="field"
                v-model="localFI.PaisOutro"
                :disabled="isDisabledEnderecoOutro"
              >
                <option value="">Selecione</option>
                <option
                  v-for="item in listaPaises"
                  :key="item.Codigo"
                  :value="item.Codigo"
                >
                  {{ item.Descricao }}
                </option>
              </select>
              <p
                v-if="camposObrigatorios.erroEnderecoOutroPais"
                class="form-field-error"
              >
                Campo obrigatório
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <ModalAlerta
      :mostrar="modalAlerta.mostrar"
      :tipo="modalAlerta.tipo"
      :titulo="modalAlerta.titulo"
      :mensagem="modalAlerta.mensagem"
      @fechar="modalAlerta.mostrar = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";
import LabelDisclaimer from "@/components/LabelDisclaimer.vue";
import { validarCampoCep, ufs } from "@/utils/formUtils";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
export default {
  name: "CadastroOutros_DadosEmpresa",
  props: ["Edicao"],
  mixins: [emailValidatorMixin],
  components: { LabelDisclaimer, ModalAlerta },
  computed: {
    ...mapGetters({
      user: "auth/user",
      infoEmpresa: "GET_FI_INFO_EMPRESA",
      listaAtividades: "GET_LISTA_ATIVIDADES",
      configuracoes: "GET_CONFIGURACAO",
      listaPaises: "GET_LISTA_PAISES",
      listaNaturezaJuridica: "GET_LISTA_NATUREZA_JURIDICA",
    }),
    ufs() {
      return ufs;
    },
  },
  data() {
    return {
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      isDisabledEndereco: false,
      emailErros: {},
      telefoneValido: [],
      isDisabledEnderecoOutro: false,
      isDisabledEnderecoLogradouro: false,
      isDisabledEnderecoOutroLogradouro: false,
      camposObrigatorios: {
        erroEnderecoCep: false,
        erroEnderecoLogradouro: false,
        erroEnderecoNumero: false,
        erroEnderecoBairro: false,
        erroEnderecoCidade: false,
        erroEnderecoUf: false,
        erroNaturezaJuridica: false,
        erroEnderecoPais: false,
        erroEnderecoOutroCep: false,
        erroEnderecoOutroLogradouro: false,
        erroEnderecoOutroNumero: false,
        erroEnderecoOutroBairro: false,
        erroEnderecoOutroCidade: false,
        erroEnderecoOutroUf: false,
        erroEnderecoOutroPais: false,
      },
      permitirAvancar: false,
      localFI: {
        RazaoSocial: null,
        Cnpj: null,
        Apelido: null,
        RamoAtividade: null,
        DataConstituicao: null,
        PessoaContato: null,
        Cargo: null,
        Email: null,
        Telefone: null,
        SemFinsLucrativos: null,
        Logradouro: null,
        LogradouroNumero: null,
        LogradouroComplemento: null,
        NaturezaJuridicaId: null,
        NaturezaJuridicaDataSincronizacao: null,
        Bairro: null,
        Cidade: null,
        Uf: null,
        Pais: null,
        Cep: null,
        LogradouroOutro: null,
        LogradouroNumeroOutro: null,
        LogradouroComplementoOutro: null,
        BairroOutro: null,
        CidadeOutro: null,
        UfOutro: null,
        PaisOutro: null,
        CepOutro: null,
        EmitirExtratoPapel: false,
        EnderecoCorrespondencia: "1",
      },
      apelidoError: "",
      configuracaoApelido: "",
      inicializado: false,
    };
  },
  mounted() {
    this.localFI = this.infoEmpresa;
    if (this.infoEmpresa != null && this.infoEmpresa.DataConstituicao != null) {
      this.localFI.DataConstituicao = this.converterData(
        this.infoEmpresa.DataConstituicao,
      );
    }
    if (this.localFI != null) {
      this.localFI.EnderecoCorrespondencia =
        this.infoEmpresa.CepOutro != "" && this.infoEmpresa.CepOutro != null
          ? 2
          : 1;
    }
    this.inicializado = true;
    this.validarFormulario();
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACAO",
    }),
    onValidateTelefone({ name, valid }) {
      if (!this.telefoneValido) {
        this.telefoneValido = {};
      }
      if (valid != "undefined") {
        this.telefoneValido[name] = valid;
      }
    },
    validarEmail() {
      this.validarEmailGeneric(this.localFI.Email, "Email", {
        obrigatorio: true,
      });
    },
    converterData(dataString) {
      if (dataString && dataString !== "0001-01-01T00:00:00") {
        let data = new Date(dataString);
        let ano = data.getFullYear();
        let mes = (data.getMonth() + 1).toString().padStart(2, "0");
        let dia = data.getDate().toString().padStart(2, "0");
        return `${ano}-${mes}-${dia}`;
      } else {
        return null;
      }
    },
    validarApelido(event) {
      if (this.configuracaoApelido === "S") {
        const value = event.target.value;
        const regex = /[^a-zA-Z0-9]/g;
        this.localFI.Apelido = value.replace(regex, "").slice(0, 20);
      }
    },
    checkApelidoLength(event) {
      if (!this.localFI.Apelido || this.localFI.Apelido.length < 3) {
        this.apelidoError =
          "O campo apelido deve ter no mínimo três caracteres.";
        event.target.focus();
      } else {
        this.apelidoError = "";
      }
    },
    proximaEtapa() {
      this.validarFormulario(true);
      if (this.permitirAvancar) {
        this.$store.commit("SET_ETAPA_CADASTRO", 1);
        this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", true);
        this.salvarInformacoes();
      }
    },
    validarFormulario(submeter) {
      this.permitirAvancar = true;
      var valorInvalido = false;

      var nomeDoCampo = "";
      this.camposObrigatorios = {
        erroEnderecoCep: false,
        erroEnderecoLogradouro: false,
        erroEnderecoNumero: false,
        erroEnderecoBairro: false,
        erroEnderecoCidade: false,
        erroEnderecoUf: false,
        erroEnderecoPais: false,
        erroEnderecoOutroCep: false,
        erroEnderecoOutroLogradouro: false,
        erroEnderecoOutroNumero: false,
        erroEnderecoOutroBairro: false,
        erroEnderecoOutroCidade: false,
        erroEnderecoOutroUf: false,
        erroEnderecoOutroPais: false,
      };
      if (!this.localFI.Apelido && this.configuracaoApelido === "S") {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroApelido = true;
          nomeDoCampo = "Apelido";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.RamoAtividade) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroRamoAtividade = true;
          nomeDoCampo = "Ramo da Atividade";
        }
        this.permitirAvancar = false;
      }

      if (!this.localFI.NaturezaJuridicaId) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroNaturezaJuridica = true;
          nomeDoCampo = "Natureza Jurídica";
        }
        this.permitirAvancar = false;
      }

      if (!this.localFI.Telefone || this.telefoneValido.Telefone == false) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTelefone = true;
          nomeDoCampo = "Telefone";
        }
        if (this.telefoneValido.Telefone == false) {
          valorInvalido = true;
        }
        this.permitirAvancar = false;
      }

      if (Object.values(this.emailErros).some((erro) => erro !== "")) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEmail = true;
          nomeDoCampo = "E-mail";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.Cep) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoCep = true;
          nomeDoCampo = "CEP do Endereço Comercial";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.Logradouro) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoLogradouro = true;
          nomeDoCampo = "Logradouro do Endereço Comercial";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.LogradouroNumero) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoNumero = true;
          nomeDoCampo = "Número do Endereço Comercial";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.Bairro) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoBairro = true;
          nomeDoCampo = "Bairro do Endereço Comercial";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.Cidade) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoCidade = true;
          nomeDoCampo = "Cidade do Endereço Comercial";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.Uf) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoUf = true;
          nomeDoCampo = "Uf do Endereço Comercial";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.Pais) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoPais = true;
          nomeDoCampo = "País do Endereço Comercial";
        }
        this.permitirAvancar = false;
      }
      if (!this.localFI.CepOutro && this.localFI.EnderecoCorrespondencia == 2) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoOutroCep = true;
          nomeDoCampo = "CEP do Endereço de Correspondência";
        }
        this.permitirAvancar = false;
      }
      if (
        !this.localFI.LogradouroOutro &&
        this.localFI.CepOutro &&
        this.localFI.EnderecoCorrespondencia == 2
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoOutroLogradouro = true;
          nomeDoCampo = "Logradouro do Endereço de Correspondência";
        }
        this.permitirAvancar = false;
      }
      if (
        !this.localFI.LogradouroNumeroOutro &&
        this.localFI.CepOutro &&
        this.localFI.EnderecoCorrespondencia == 2
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoOutroNumero = true;
          nomeDoCampo = "Número do Endereço de Correspondência";
        }
        this.permitirAvancar = false;
      }
      if (
        !this.localFI.BairroOutro &&
        this.localFI.CepOutro &&
        this.localFI.EnderecoCorrespondencia == 2
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoOutroBairro = true;
          nomeDoCampo = "Bairro do Endereço de Correspondência";
        }
        this.permitirAvancar = false;
      }
      if (
        !this.localFI.CidadeOutro &&
        this.localFI.CepOutro &&
        this.localFI.EnderecoCorrespondencia == 2
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoOutroCidade = true;
          nomeDoCampo = "Cidade do Endereço de Correspondência";
        }
        this.permitirAvancar = false;
      }
      if (
        !this.localFI.UfOutro &&
        this.localFI.CepOutro &&
        this.localFI.EnderecoCorrespondencia == 2
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoOutroUf = true;
          nomeDoCampo = "Uf do Endereço de Correspondência";
        }
        this.permitirAvancar = false;
      }
      if (
        !this.localFI.PaisOutro &&
        this.localFI.CepOutro &&
        this.localFI.EnderecoCorrespondencia == 2
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroEnderecoOutroPais = true;
          nomeDoCampo = "País do Endereço de Correspondência";
        }
        this.permitirAvancar = false;
      }
      if (submeter && nomeDoCampo != "") {
        if (valorInvalido) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`,
          };
        } else {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} não foi informado ou é inválido, preencha a informação para avançar.`,
          };
        }
      }

      return this.permitirAvancar;
    },
    salvarInformacoes() {
      this.validarApelido({ target: { value: this.localFI.Apelido } });
      if (this.apelidoError) {
        return false;
      }
      this.$store.commit("SET_FI_SALVAR_INFO_BASICAS", this.localFI);
      this.$store.commit("SET_FI_SALVAR_INFO", true);
    },
    salvarAlteracoesLocalmente() {
      this.$store.commit("SET_FI_SALVAR_INFO_BASICAS", this.localFI);
      this.validarFormulario();
    },
    async validarCep(objDados, somenteValidar = false) {
      if (objDados.Cep) {
        var result = await validarCampoCep(objDados, {
          somenteValidar: somenteValidar,
        });
        if (result) {
          this.isDisabledEndereco = true;
          this.isDisabledEnderecoLogradouro = true;
          if (objDados.Logradouro == "") {
            this.isDisabledEnderecoLogradouro = false;
          }
        } else {
          this.isDisabledEndereco = false;
          this.isDisabledEnderecoLogradouro = false;
        }
      }
    },
    async validarCepOutro(objDados, somenteValidar = false) {
      if (objDados.CepOutro) {
        var result = await validarCampoCep(objDados, {
          somenteValidar: somenteValidar,
          tipoEndereco: "Outro",
        });
        if (result) {
          this.isDisabledEnderecoOutro = true;
          this.isDisabledEnderecoOutroLogradouro = true;
          if (objDados.LogradouroOutro == "")
            this.isDisabledEnderecoOutroLogradouro = false;
        } else {
          this.isDisabledEnderecoOutro = false;
          this.isDisabledEnderecoOutroLogradouro = false;
        }
      }
    },
    limparCamposEnderecoCorrespondencia() {
      this.localFI.LogradouroOutro = null;
      this.localFI.BairroOutro = null;
      this.localFI.CidadeOutro = null;
      this.localFI.UfOutro = null;
      this.localFI.PaisOutro = null;
      this.localFI.CepOutro = null;
      this.salvarAlteracoesLocalmente();
    },
  },
  created() {
    this.fetchConfiguracao("EXIBIR APELIDO");
  },
  watch: {
    "localFI.Cep"(newCep) {
      if (newCep) {
        this.validarCep(this.localFI, true);
        if (this.localFI.EnderecoCorrespondencia == 2) {
          this.validarCepOutro(this.localFI, true);
        }
      }
    },
    infoEmpresa() {
      this.localFI = this.infoEmpresa;
      if (
        this.infoEmpresa != null &&
        this.infoEmpresa.DataConstituicao != null
      ) {
        this.localFI.DataConstituicao = this.converterData(
          this.infoEmpresa.DataConstituicao,
        );
      }
    },
    configuracoes(newVal) {
      if (newVal && newVal.Valor) {
        this.configuracaoApelido = newVal.Valor;
      } else {
        console.error("Configurações não são válidas:", newVal);
        this.configuracaoApelido = [];
      }
    },
  },
};
</script>

<!--<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');


.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
    border-bottom: 1px solid #D0D5DD;
    /* Borda */
}

.categoriaAgrupamentoFormulario {
    width: 10%;
    margin-right: 15px;

    h5 {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
    }

}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }




    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }


    label {
        font-family: 'Inter', sans-serif;
        /* Fonte Inter */
        font-weight: 500;
        /* Peso médio */
        font-size: 14px;
        /* Tamanho da fonte */
        line-height: 20px;
        /* Altura da linha */
        color: #344054;
        /* Cor */
        display: block;
        /* Garante que a label fique acima do input */
        margin-bottom: 8px;
        /* Espaçamento entre a label e o input abaixo dela */
    }

}





.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;

    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>-->
